/*
 * Process Slate Shopify theme
 * Copyright 2020 Process Creative
 *
 * Version:
 *    1.0.0 - 2020/04/26
 */
'use strict'; //Strict Mode enforced

//Imports

require('core-js/stable');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

require('./../components/popup/NewsletterPopup');

require('./../objects/currency/CurrencySelector');

require('./../objects/layout/TopBar');

require('./../objects/icon/Icon');

require('./../objects/product/ProductThumbnail');

require('./../objects/content/ReadMore');

require('./../sections/header/Header');

require('./../sections/footer/Footer');

require('./../sections/free-sample/FreeSample');

require('./../template/index');

require('./../template/product');

require('./../template/customers/LoginRegister');

require('./../template/customers/Addresses');

require('./../template/collection/collection');

require('../template/Faq');

require('../template/Article');

require('../template/CartTemplate');

require('../template/Password');

require('../template/store-locator');

require('../tools/GorgiasStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }